import axios from 'axios'

const API_PATH = '/admins/marketplace/product/revenues'


const MarketplaceProductsRevenuesApi = {
  /**
   * @param {object} params - query string parameters
   * @return {object} revenue object that includes selling_price, seller_revenue, and commission_fee
   */
  get: async ({ params }) => {
    const response = axios.get(API_PATH,{ params })
    return response
  }

}

export default MarketplaceProductsRevenuesApi
